"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/PatientTable/ImportPatients/ImportStatusBar.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _format = require('../format');

const plural = (n, one, many) => `${_format.formatCount.call(void 0, n)} ${n === 1 ? one : many}`

const joinNames = (names) => names.length <= 1
  ? names.join('')
  : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`










/* The Directory import above the table, in the archive bar's place: its
 * progress bar while it runs (b1-6), then a result line (b1-7), or what got
 * in when it stopped (b1-8). */
const ImportStatusBar = ({ status, onDownload, onShowPatients, onImportAgain, onDismiss }) => {
  const { Result: result, FileName: fileName, Total: total } = status
  const name = _react2.default.createElement('b', { className: "dir-import-bar--file", title: fileName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}},  fileName )

  if (status.State === 'running') {
    const label = `Importing ${fileName}`
    const percent = total > 0 ? Math.min(100, Math.round(result.Done / total * 100)) : 0
    return (
      _react2.default.createElement('div', { className: "dir-progress-list", __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}
        , _react2.default.createElement('div', { className: "dir-progress dir-import-bar--progress" , role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}
          , _react2.default.createElement('span', { className: "dir-progress--label dir-import-bar--label" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}
            , _react2.default.createElement('span', { className: "dir-import-bar--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}, "Importing " ,  name )
            , _react2.default.createElement('span', { className: "dir-import-bar--count", __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}, " · "  ,  _format.formatCount.call(void 0, result.Done) , " of "  ,  plural(total, 'patient', 'patients') )
          )
          , _react2.default.createElement('div', {
            className: "dir-progress--track",
            role: "progressbar",
            'aria-label': label,
            'aria-valuemin': 0,
            'aria-valuemax': total,
            'aria-valuenow': result.Done, __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}

            , _react2.default.createElement('div', { className: "dir-progress--fill", style: { width: `${percent}%` }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}} )
          )
        )
      )
    )
  }

  const close = (
    _react2.default.createElement('button', { type: "button", className: "dir-import-bar--close", 'aria-label': "Dismiss", onClick: onDismiss, __self: this, __source: {fileName: _jsxFileName, lineNumber: 54}}, "×")
  )
  const tagNames = status.Tags.map(t => t.Name)
  const inCount = result.Created + result.Matched
  // Tagged counts the patients that got every tag; a tag write that failed
  // twice leaves some without it (review F-7).
  const tagged = Math.min(result.Tagged, inCount)
  const taggedText = tagged === inCount
    ? `${inCount === 1 ? 'It is' : `All ${_format.formatCount.call(void 0, inCount)} are`} tagged`
    : tagged === 0
      ? `${inCount === 1 ? 'It is' : 'They are'} not tagged`
      : `${_format.formatCount.call(void 0, tagged)} of the ${_format.formatCount.call(void 0, inCount)} ${tagged === 1 ? 'is' : 'are'} tagged`

  if (status.State === 'stopped') {
    return (
      _react2.default.createElement('div', { role: "status", className: "broadcast-banner broadcast-banner--danger dir-import-bar"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}
        , _react2.default.createElement('span', { className: "dir-import-bar--result", __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}, "The import of "
             ,  name , " stopped after "   ,  _format.formatCount.call(void 0, result.Done) , " of "  ,  plural(total, 'patient', 'patients') , ": the connection to the server was lost."
          , ' ', "Those " ,  _format.formatCount.call(void 0, inCount) , " are in the Directory"    ,  tagNames.length > 0 && tagged === inCount ? ' and tagged' : '' , "."
          ,  tagNames.length > 0 && tagged < inCount && _react2.default.createElement(_react2.default.Fragment, null, " " ,  tagged === 0 ? 'None' : _format.formatCount.call(void 0, tagged) , " of them "   ,  tagged === 1 ? 'is' : 'are' , " tagged." ) 
          , ' ', _react2.default.createElement('button', { type: "button", className: "broadcast-link-button dir-import-bar--link" , onClick: onImportAgain, __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}, "Import the file again"   )
          , ' ', "to finish: the patients already in are matched, not added twice."
        )
        ,  close 
      )
    )
  }

  const existing = status.Existing === 'fill'
    ? `${plural(result.Matched, 'was', 'were')} already in the Directory; ${plural(_nullishCoalesce(result.FilledIn, () => ( 0)), 'had', 'had')} blanks filled in`
    : status.Existing === 'update'
      ? `${plural(result.Matched, 'was', 'were')} already in the Directory; ${plural(_nullishCoalesce(result.Updated, () => ( 0)), 'was', 'were')} updated from the file`
      : `${plural(result.Matched, 'was', 'were')} already in the Directory and ${result.Matched === 1 ? 'was' : 'were'} left as ${result.Matched === 1 ? 'it is' : 'they are'}`
  return (
    _react2.default.createElement('div', { role: "status", className: "broadcast-banner broadcast-banner--ok dir-import-bar"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}
      , _react2.default.createElement('span', { className: "dir-import-bar--result", __self: this, __source: {fileName: _jsxFileName, lineNumber: 89}}, "Imported "
         ,  name , ". " ,  plural(result.Created, 'new patient', 'new patients') , "; " ,  existing , "."
        ,  tagNames.length > 0 && (
          _react2.default.createElement(_react2.default.Fragment, null, " " ,  taggedText , " " , _react2.default.createElement('span', { className: "dir-import-bar--tags", __self: this, __source: {fileName: _jsxFileName, lineNumber: 92}},  joinNames(tagNames) ), ".")
        )
        ,  (_nullishCoalesce(result.ConsentRecorded, () => ( 0))) > 0 && _react2.default.createElement(_react2.default.Fragment, null, " " ,  _format.formatCount.call(void 0, _nullishCoalesce(result.ConsentRecorded, () => ( 0))) , " recorded as consented."   ) 
        ,  (_nullishCoalesce(result.Failed, () => ( 0))) > 0 && (
          _react2.default.createElement(_react2.default.Fragment, null, " " ,  plural(_nullishCoalesce(result.Failed, () => ( 0)), 'row', 'rows') , " couldn't be written:"   , ' '
            , _react2.default.createElement('button', { type: "button", className: "broadcast-link-button dir-import-bar--link" , onClick: onDownload, __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}, "download them" )
            ,  (_nullishCoalesce(status.FailedListed, () => ( 0))) < (_nullishCoalesce(result.Failed, () => ( 0))) && _react2.default.createElement(_react2.default.Fragment, null, " (the first "   ,  _format.formatCount.call(void 0, _nullishCoalesce(status.FailedListed, () => ( 0))) , " of "  ,  _format.formatCount.call(void 0, _nullishCoalesce(result.Failed, () => ( 0))) , ")") 
            , ' ', "or", ' '
            , _react2.default.createElement('button', { type: "button", className: "broadcast-link-button dir-import-bar--link" , onClick: onImportAgain, __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}, "import the file again"   ), " to finish "   , result.Failed === 1 ? 'it' : 'them', "."
          )
        )
        ,  status.NotImported > 0 && (
          _react2.default.createElement(_react2.default.Fragment, null, " " ,  plural(status.NotImported, "row couldn't", "rows couldn't") , " be imported:"  , ' '
            , _react2.default.createElement('button', { type: "button", className: "broadcast-link-button dir-import-bar--link" , onClick: onDownload, __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}}, "download them" )
          )
        )
        ,  tagNames.length > 0 && tagged > 0 && (
          _react2.default.createElement(_react2.default.Fragment, null
            , ' · '
            , _react2.default.createElement('button', { type: "button", className: "broadcast-link-button dir-import-bar--link" , onClick: onShowPatients, __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}}, "show the "
                ,  plural(tagged, 'patient', 'patients') 
            )
          )
        )
      )
      ,  close 
    )
  )
}

exports. default = ImportStatusBar
